import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { LocationData } from "../../../models/LocationData";
import DataSvc from "../../../services/dataSvc";
import { TimeUnitSelect } from "../../AnalysisCollectionsComponents/CollectionChartArea/LineChart/TimeUnitSelect";
import { TextFileDownload } from "../../Common/TextFileDownload";
import { TimespanPicker } from "../TimespanPicker";
import { useTimespanPicker } from "../TimespanPicker/hooks";
import "./styles.scss";

type IDownloadMetricsProps = {
  locations: LocationData[];
  organizationId: string;
};

export const DownloadMetrics: React.FC<IDownloadMetricsProps> = ({
  locations,
  organizationId,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`dataDownloadPage.downloadMetrics.${key}`);

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">("day");
  const timespan = useTimespanPicker();

  const queryKey = useMemo(
    () => [
      "download-metrics",
      timespan.timespan,
      timeUnit,
      locations.map((location) => location.id.toString()),
    ],
    [timespan, timeUnit, locations]
  );
  const queryFunction = useCallback(async () => {
    const data = await DataSvc.getFacilityDataMetrics({
      organizationId,
      timespan: timespan.timespan,
      timeUnit,
      locations,
    });
    return { filename: "metrics", content: data };
  }, [timespan, timeUnit, locations, organizationId]);

  return (
    <div className="white-border-panel download-metrics">
      <h3>{t("download_metrics")}</h3>
      <div className="content">
        <div className="download-metrics-controls">
          <TimespanPicker timespan={timespan} />
          <TimeUnitSelect timeUnit={timeUnit} setTimeUnit={setTimeUnit} />
        </div>
        <TextFileDownload queryKey={queryKey} queryFunction={queryFunction} />
      </div>
    </div>
  );
};
